/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリースエディタ移行APIのリクエストボディ
 * @export
 * @interface MigratePressReleaseEditorVersionRequestBody
 */
export interface MigratePressReleaseEditorVersionRequestBody {
    /**
     * 移行するかどうか
     * @type {boolean}
     * @memberof MigratePressReleaseEditorVersionRequestBody
     */
    shouldMigrate: boolean;
}

export function MigratePressReleaseEditorVersionRequestBodyFromJSON(json: any): MigratePressReleaseEditorVersionRequestBody {
    return MigratePressReleaseEditorVersionRequestBodyFromJSONTyped(json, false);
}

export function MigratePressReleaseEditorVersionRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigratePressReleaseEditorVersionRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shouldMigrate': json['should_migrate'],
    };
}

export function MigratePressReleaseEditorVersionRequestBodyToJSON(value?: MigratePressReleaseEditorVersionRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'should_migrate': value.shouldMigrate,
    };
}

